import { AwellText } from '../components/awell-text'

import type { AwellTextDefinition } from '../components/awell-text'

function renderText(value: string) {
  try {
    const parsedDescription: AwellTextDefinition = JSON.parse(value)
    return Array.isArray(parsedDescription) ? <AwellText definition={parsedDescription.at(0)} /> : null
  } catch {
    return value
  }
}

export { renderText }
